import { render, staticRenderFns } from "./AsyncItem.vue?vue&type=template&id=a0bc27c2&scoped=true&"
import script from "./AsyncItem.vue?vue&type=script&lang=js&"
export * from "./AsyncItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bc27c2",
  null
  
)

export default component.exports